// API configuration
const isDevelopment = process.env.NODE_ENV === 'development';

// Base URL för API-anrop
const baseUrl = isDevelopment 
    ? 'http://localhost:3002/api'  // Uppdaterad port till 3002
    : '/api';  // Använd relativ URL i produktion

console.log('API Base URL:', baseUrl);
console.log('Environment:', process.env.NODE_ENV);

const config = {
  api: {
    baseUrl,
    endpoints: {
      contact: `${baseUrl}/contact`
    }
  }
};

export default config; 